import { createHead } from '@vueuse/head'

import type { UserModule } from '~/types'

export const install: UserModule = (app) => {
  const head = createHead({
    title: 'PREDiCT Large Loss',
  })
  app.use(head)
}

export default { install }
